$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function getCookieConsentValue(key) {
  const cookieString = document.cookie;
  const cookies = cookieString.split(";").reduce((acc, curr) => {
    const [k, v] = curr.split("=");
    if (k && v) acc[k.trim()] = decodeURIComponent(v);
    return acc;
  }, {});

  const consent = cookies["cookieyes-consent"];
  if (!consent) return null;

  const consentObj = consent.split(",").reduce((acc, pair) => {
    const [k, v] = pair.split(":");
    if (k && v) acc[k.trim()] = v.trim();
    return acc;
  }, {});

  return consentObj[key] || null;
}

// FINAL – WORKS ALWAYS – Dawn cart count fix (Nov 2025)
(function () {
  function setCount(count) {
    const display = count > 99 ? '99+' : count;
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.textContent = display;               // ← only changes text, nothing else
    });
  }

  // 1. Always correct on first page load
  fetch('/cart.js?ts=' + Date.now())
    .then(r => r.json())
    .then(cart => setCount(cart.item_count));

  // 2. Poll every 1.5 seconds while page is visible (this is what finally defeats the bug)
  let interval = setInterval(() => {
    if (!document.hidden) {
      fetch('/cart.js?ts=' + Date.now())   // ts= bypasses any cache
        .then(r => r.json())
        .then(cart => setCount(cart.item_count));
    }
  }, 1500);

  // Clean up interval when leaving the page
  window.addEventListener('pagehide', () => clearInterval(interval));
  window.addEventListener('beforeunload', () => clearInterval(interval));
})();

$(document).ready(function () {

  // get the shortest path of image
  var shortestImg = function (el) {
    var lastSegment = el.split("/").pop();
    if (lastSegment.indexOf('?') > 0) {
      return lastSegment.substring(0, lastSegment.indexOf('?'));
    }
    else {
      return lastSegment;
    }
  }

  if ($('.product-section .slider-large > .slides').length > 0) {
    $('.product-section .slider-large > .slides>div').removeClass('d-none');
    if ($('.product-section .slider-large > .slides').hasClass('slick-initialized')) {
      $('.product-section .slider-large > .slides').slick('unslick');
    }
    $('.product-section .slider-large > .slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      speed: 800,
      arrows: true,
      fade: true,
      draggable: false,
      asNavFor: '.product-section .slider-thumb',
    });
    $('.product-section .slider-large > .slides').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      var direction;
      if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
        direction = 'Left';
      } else if (nextSlide > currentSlide || (currentSlide === (slick.$slides.length - 1) && nextSlide === 0)) {
        direction = 'Right';
      } else {
        direction = 'Left';
      }

      var nextSlideImg = shortestImg(jQuery(".product-section .slider-large .slick-slide[data-slick-index=" + nextSlide + "]").find("img").attr("src"));

      var currentSlideImg = shortestImg(jQuery(".product-section .slider-large .slick-slide[data-slick-index=" + currentSlide + "]").find("img").attr("src"));

      var slideParameters = currentSlide + "-" + nextSlide + " | " + currentSlideImg + " - " + nextSlideImg;

      window.dataLayer.push({
        'event': 'slideChangeEvent',
        'direction': direction,
        'slideParameters': slideParameters
      });
    });
  }

  if ($('.celeb-slider').length > 0) {
    $('.celeb-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      infinite: false,
      speed: 800,
      arrows: false,
      fade: false,
      draggable: true
    });
  }

  if ($('.product-section .slider-thumb').length > 0) {
    $('.product-section .slider-thumb>div').removeClass('d-none');
    if ($('.product-section .slider-thumb').hasClass('slick-initialized')) {
      $('.product-section .slider-thumb').slick('unslick');
    }
    $('.product-section .slider-thumb').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      asNavFor: '.product-section .slider-large > .slides',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 6.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 5.4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  // black friday collection slider
  if ($('.bf-collection-slider .slider-wrapper').length > 0) {
    var handleBfSlides = function () {
      if ($('.bf-collection-slider .slider-wrapper').hasClass('slick-initialized')) {
        $('.bf-collection-slider .slider-wrapper').slick('unslick');
      }
      if ($(window).width() > 992) {
        $('.bf-collection-slider .slider-wrapper').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          focusOnSelect: true
        });
      } else if ($(window).width() > 700) {
        $('.bf-collection-slider .slider-wrapper').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          focusOnSelect: true
        });
      }
      else {
        $('.bf-collection-slider .slider-wrapper').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          focusOnSelect: true
        });
      }
    }
    handleBfSlides();
    $(window).on('resize', function () {
      setTimeout(function () {
        handleBfSlides();
      }, 100);
    });
  }

  // celebrity testimonial slider
  if ($('.celebrity-testimonial-section .slider-wrapper').length > 0) {
    var handleCelebSlides = function () {
      if ($('.celebrity-testimonial-section .slider-wrapper').hasClass('slick-initialized')) {
        $('.celebrity-testimonial-section .slider-wrapper').slick('unslick');
      }
      if ($(window).width() > 992) {
        $('.celebrity-testimonial-section .slider-wrapper').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          arrows: true,
          draggable: false
        });
      } else {
        $('.celebrity-testimonial-section .slider-wrapper').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          arrows: true,
          draggable: false
        });
      }
    };

    handleCelebSlides();
    $(window).on('resize', function () {
      setTimeout(function () {
        handleCelebSlides();
      }, 100);
    });
  }

  // customer review slider
  if ($('.customer-review-section .review-wrapper').length > 0) {
    $('.customer-review-section .review-wrapper').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if ($('.doctors-section .gallery-wrapper').length > 0 && $(window).width() < 767) {
    $('.doctors-section .gallery-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false
    })
  }
  if ($('.celebrity-slider-section .slider-wrapper').length > 0) {
    $('.celebrity-slider-section .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false
    })
  }

  if ($('.customer-video-testimonial .testimonial-wrapper').length > 0 && $(window).width() < 767) {
    $('.customer-video-testimonial .testimonial-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false
    })
  }

  $("header .menu-wrapper .navbar .cart-wrapper .shop-btn").on("click", function (e) {
    if ($(this).hasClass("active")) {
      $("header .menu-wrapper .navbar .navbar-collapse").removeClass("show");
      $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu").removeClass("show");
      $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").removeClass("show");
      $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .shop-btn").show();
      $("header .menu-wrapper .navbar .navbar-collapse .navbar-nav>.nav-item").show();
      $(this).removeClass("active");
      // $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu").hide();
    }
    else {
      $("header .menu-wrapper .navbar .navbar-collapse").addClass("show");
      $("header .menu-wrapper .navbar .navbar-collapse .navbar-nav>.nav-item").hide();
      $("header .menu-wrapper .navbar .navbar-collapse .navbar-nav>.nav-item.shop-menu").show().addClass("show");
      $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .shop-btn").hide();
      $(this).addClass("active");
      if ($("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").hasClass("show")) {
        setTimeout(function () {
          $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").addClass("show");
        }, 50);
        return true;
      }
      else {
        $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").addClass("show");
        setTimeout(function () {
          $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").addClass("show");
        }, 50);
      }
    }
  });

  $(".navbar-toggler").on("click", function (e) {
    $("header .menu-wrapper .navbar .navbar-collapse .navbar-nav>.nav-item").show();
    $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu").removeClass("show").hide();
    $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .dropdown-menu").removeClass("show");
    $("header .menu-wrapper .navbar .cart-wrapper .shop-btn").removeClass("active");
    $("header .menu-wrapper .navbar .navbar-collapse .nav-item.shop-menu .shop-btn").show();
  });

  // show form
  $("header .logo-wrapper .search>button,header .menu-wrapper .navbar .bar-wrapper .search>button").on("click", function (e) {
    $(this).closest(".search").find(".search-bar").show();
  });

  // hide form
  $("header .logo-wrapper .search .search-bar .search-form__container .search-bar__actions button,header .menu-wrapper .navbar .bar-wrapper .search .search-bar .search-form__container .search-bar__actions button").on("click", function (e) {
    $(this).closest(".search-bar").hide();
  });

  $('a[href^="#"]').on("click", function (e) {
    var t = $(this).attr("href");
    if ($(t).length > 0) {
      $("html, body").animate({
        scrollTop: $(t).offset().top
      }, 1500)
    }
  });

  // collection module in homepage
  var pl_move_collection = ((jQuery(window).width() - 1370) / 2) - 15;
  jQuery(".collection-module .content-side").css({ "padding-left": pl_move_collection + 'px' });
  if (jQuery(window).width() < 1370) {
    jQuery(".collection-module .content-side").css({ "padding-left": 0 });
  }
  jQuery(window).on('resize', function () {
    var pl_move_collection = ((jQuery(window).width() - 1370) / 2) - 15;
    jQuery(".collection-module .content-side").css({ "padding-left": pl_move_collection + 'px' });
    if (jQuery(window).width() < 1370) {
      jQuery(".collection-module .content-side").css({ "padding-left": 0 });
    }
  });

  // Move collection module product slider
  if ($('.collection-module .slider-wrapper').length > 0) {
    var handleCollectionSlides = function () {
      if ($('.collection-module .slider-wrapper').hasClass('slick-initialized')) {
        $('.collection-module .slider-wrapper').slick('unslick');
      }
      if ($(window).width() > 1200) {
        $('.collection-module .slider-wrapper').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          focusOnSelect: true
        });
      } else if ($(window).width() > 700) {
        $('.collection-module .slider-wrapper').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          focusOnSelect: true
        });
      }
      else {
        $('.collection-module .slider-wrapper').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          focusOnSelect: true
        });
      }
    }
    handleCollectionSlides();
    $(window).on('resize', function () {
      setTimeout(function () {
        handleCollectionSlides();
      }, 100);
    });
  }

  // Move collection image slider desktop
  if ($('.collection-module .img-slider-side .desktop_slider').length > 0) {
    var handleMoveCollectionImgSlides = function () {
      if ($('.collection-module .img-slider-side .desktop_slider').hasClass('slick-initialized')) {
        $('.collection-module .img-slider-side .desktop_slider').slick('unslick');
      }
      $('.collection-module .img-slider-side .desktop_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        autoplay: true,
        infinite: true,
        speed: 800,
        fade: true
      });
    }
    handleMoveCollectionImgSlides();
    $(window).on('resize', function () {
      setTimeout(function () {
        handleMoveCollectionImgSlides();
      }, 100);
    });
  }

  // Move collection image slider mobile
  if ($('.collection-module .img-slider-side .mobile_slider').length > 0) {
    var handleMoveCollectionImgSlidesMobile = function () {
      if ($('.collection-module .img-slider-side .mobile_slider').hasClass('slick-initialized')) {
        $('.collection-module .img-slider-side .mobile_slider').slick('unslick');
      }
      $('.collection-module .img-slider-side .mobile_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        autoplay: true,
        infinite: true,
        speed: 800,
        fade: true
      });
    }
    handleMoveCollectionImgSlidesMobile();
    $(window).on('resize', function () {
      setTimeout(function () {
        handleMoveCollectionImgSlidesMobile();
      }, 100);
    });
  }

  // range slider for comparison table
  $(function () {
    const settings = {
      fill: '#d31245',
      background: '#C4C4C4'
    }
    var compareTableWrap = document.getElementById('compareTableWrap');
    var sliderInputs = document.querySelectorAll(".sliderDiv input[type='range']");

    var updateTableScroll = function (slider) {
      if (!compareTableWrap) {
        return;
      }

      var maxScroll = compareTableWrap.scrollWidth - compareTableWrap.clientWidth;
      if (maxScroll <= 0) {
        return;
      }

      var min = parseFloat(slider.min) || 0;
      var max = parseFloat(slider.max) || 100;
      var value = parseFloat(slider.value);

      if (isNaN(value)) {
        value = 0;
      }

      value = Math.min(Math.max(value, min), max);

      var step = parseFloat(slider.step);
      if (!step || step <= 0 || isNaN(step)) {
        step = (max - min) / 100 || 1;
      }

      if (value - min <= step / 2) {
        value = min;
      }
      if (max - value <= step / 2) {
        value = max;
      }

      var percent = (value - min) / (max - min || 1);
      percent = Math.max(0, Math.min(1, percent));

      var targetLeft = Math.round(percent * maxScroll);
      if (targetLeft <= 8) {
        targetLeft = 0;
      }

      if (typeof compareTableWrap.scrollTo === 'function') {
        compareTableWrap.scrollTo({ left: targetLeft, behavior: 'auto' });
      } else {
        compareTableWrap.scrollLeft = targetLeft;
      }
    };

    Array.prototype.forEach.call(sliderInputs, function (slider) {
      slider.addEventListener('input', function () {
        updateTableScroll(slider);
      }, { passive: true });

      slider.addEventListener('change', function () {
        updateTableScroll(slider);
      }, { passive: true });

      updateTableScroll(slider);
    });

    $("#compareTableWrap").on('scroll', function () {
      var maxScroll = this.scrollWidth - this.clientWidth;
      var scrollLeft = this.scrollLeft;

      if (scrollLeft <= 8) {
        scrollLeft = 0;
        this.scrollLeft = 0;
      }

      var scrollPercentage = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
      var bg = `linear-gradient(90deg, ${settings.fill} ${scrollPercentage}%, ${settings.background} ${scrollPercentage}%)`;
      if (scrollPercentage <= 8) {
        scrollPercentage = 0;
      }
      $('#slider1, #slider').css({ "background": bg });
      $('#slider1, #slider').val(scrollPercentage);
    });

  });

  if ($('.plate-slider-section .main-img-slider div').length > 0) {
    $('.plate-slider-section .main-img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false,
      asNavFor: '.plate-slider-section .thumb-slider,.plate-slider-section .content-slider'
    })
  }
  if ($('.plate-slider-section .thumb-slider div').length > 0) {
    $('.plate-slider-section .thumb-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      draggable: false,
      accessibility: false,
      asNavFor: '.plate-slider-section .main-img-slider,.plate-slider-section .content-slider'
    })
  }
  if ($('.plate-slider-section .content-slider').length > 0) {
    $('.plate-slider-section .content-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      draggable: false,
      asNavFor: '.plate-slider-section .thumb-slider,.plate-slider-section .main-img-slider'
    })
  }

  if ($('.pro-sport-tab-section .tab-pane.active .img-wrapper').length > 0 && $(window).width() < 767) {
    $('.pro-sport-tab-section .tab-pane.active .img-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: false,
      arrows: true,
      draggable: false
    })
  }
  $('.pro-sport-tab-section .tab-pane').each(function () {
    if ($(this).find(".img-wrapper").children().length > 1) {
      $(this).find(".img-wrapper").addClass("more_slides");
    }
  })
  var pro_sport_slider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: false,
    arrows: true,
    draggable: false
  }
  $(".pro-sport-tab-section .nav-pills a").on("click", function () {
    $('html,body').stop();
    if ($(window).scrollTop() < ($('.pro-sport-tab-section').offset().top)) {
      $('html,body').animate({ scrollTop: $('.pro-sport-tab-section').offset().top + 2 }, 1000);
    }
    var btn_id = $(this).attr('id');
    if ($(window).width() < 767) {
      setTimeout(function () {
        $(".pro-sport-tab-section").find(".tab-pane").filter('[aria-labelledby=' + btn_id + ']').find(".img-wrapper").slick(pro_sport_slider);
      }, 1000);
    }
  });


  $('.media-' + $('.form-check-input:checked').attr('data-media-id')).click();

  // $('.form-check-input').on('change', function(){
  //     var mediaId = $(this).attr('data-media-id');
  //     if ($('.media-'+mediaId)) {
  //         $('.media-'+mediaId).click();
  //     }
  // });

  // showing special text on click of radio button
  $('.color-wrapper .form-check-label').on('click', function () {
    var labelNumber = $(this).attr('for');
    $(this).closest('form').find(".row>.color-title>span").addClass('d-none');
    $(this).closest('form').find(".row>.color-title>span[data-target='" + labelNumber + "']").removeClass('d-none');

    $(this).closest('.color-wrapper').find(".color-title>span").addClass('d-none');
    $(this).closest('.color-wrapper').find(".color-title>span[data-target='" + labelNumber + "']").removeClass('d-none');

    $(this).closest('form').find("button.product-form__cart-submit").addClass('d-none');
    $(this).closest('form').find(".buy-btn-" + $(this).closest(".form-check").find("input").val()).removeClass('d-none');

    var colorID = $(this).closest(".form-check").find(".form-check-input").val();
    var qtyVal = $(this).closest('form').find('.quantity-incrementor input[type="number"]').val();
    if ($(this).closest('form').find('.quantity-incrementor input[type="number"]').val() <= 0) {
      var newHref = '/cart/' + colorID + ':1?channel=buy_button';
    }
    else {
      var newHref = '/cart/' + colorID + ':' + qtyVal + '?channel=buy_button';
    }
    $(this).closest('form').find(".order-now-btn>a").attr('href', newHref);
  });

  $(document).on('click', '.form-check', function () {
    $(this).find('input').prop('checked', true);
    var mediaId = $(this).find('input').attr('data-media-id');
    if ($('.media-' + mediaId)) {
      $('.media-' + mediaId).click();
    }

    var target = $(this).find('input').attr('data-target');
    var value = $(this).find('input').val();
    $(target).val(value);
    if ($('#product-price-' + value)) {
      $('.price-item.active').removeClass('active');
      $('#product-price-' + value).addClass('active');
    }
    if ($('.multiple-quantity-selector[data-multiple-quantity="multiple-quantity-' + value + '"]')) {
      $(this).closest("form").find('.multiple-quantity-selector.active').removeClass('active');
      $(this).closest("form").find('.multiple-quantity-selector[data-multiple-quantity="multiple-quantity-' + value + '"]').addClass('active');
    }
  });

  var initial_total_price = parseFloat($(".product-section .content-side .product--price .price-item >span>strike").text().replace('$', ''));
  var initial_discounted_price = parseFloat($(".product-section .content-side .product--price .price-item>.f-color-red").text().replace('$', ''));

  jQuery(function () {
    $(".product-section .content-side .product-form__item--submit .quantity-incrementor input,[data-product-form] .quantity-incrementor input").val("1");
  });

  $(document).on('click', '.multiple-quantity-selector .single a', function () {
    var target_qut = $(this).attr('data-quantity');
    var target_disc = $(this).attr('data-discount');
    $(".multiple-quantity-selector .single").removeClass("active");
    $(".multiple-quantity-selector .single a[data-quantity='" + target_qut + "']").closest(".single").addClass("active");
    $(".product-section .content-side .product-form__item--submit .quantity-incrementor input,[data-product-form] .quantity-incrementor input").val(target_qut * $('.custom-quantity-incrementor input[name="custom_quantity"]').val());

    var total_price = target_qut * initial_total_price;
    var discounted_price = total_price - target_disc;

    $(".product-section .content-side .product--price .price-item>.f-color-red").text("$" + discounted_price);
    $(".product-section .content-side .product--price .price-item >span>strike").text("$" + total_price.toFixed(2));

    if (target_qut != "1") {
      $(".quantity-incrementor").hide();
      $(".custom-quantity-incrementor").show();
    }
    else {
      $(".quantity-incrementor").show();
      $(".custom-quantity-incrementor").hide();
    }
  });

  $('.custom-quantity-incrementor .custom_decrease').on('click', function () {
    var qty = $(this).closest('.custom-quantity-incrementor').find('input[name="custom_quantity"]');
    if (qty) {
      var val = parseInt(qty.val());
      val = isNaN(val) ? 0 : val;
      val--;
      $('.custom-quantity-incrementor input[name="custom_quantity"]').val(val);
      $('.quantity-incrementor input[name="quantity"]').val(val * parseInt($(".multiple-quantity-selector .single.active a").attr("data-quantity")));
    }
  });

  $('.custom-quantity-incrementor .custom_increase').on('click', function () {
    var qty = $(this).closest('.custom-quantity-incrementor').find('input[name="custom_quantity"]');
    if (qty) {
      var val = parseInt(qty.val());
      val = isNaN(val) ? 0 : val;
      val++;
      $('.custom-quantity-incrementor input[name="custom_quantity"]').val(val);
      $('.quantity-incrementor input[name="quantity"]').val(val * parseInt($(".multiple-quantity-selector .single.active a").attr("data-quantity")));
    }
  });

  // $('.form-check-input-1').on('change', function(){
  //     var value = $(this).val();
  //     var target = $(this).attr('data-target');
  //     $(target).val(value);
  //     $(this).prop('checked', true);
  // });

  $('[btn-decrease]').on('click', function () {
    var qty = $(this).closest('.quantity-incrementor').find('input[name="quantity"]');
    if (qty) {
      var val = parseInt(qty.val());
      val = isNaN(val) ? 0 : val;
      val--;
      $('.quantity-incrementor input[name="quantity"]').val(val);
      if (val >= 1) {
        $(".order-now-btn").each(function () {
          var link = $(this).find("a").attr('href');
          var updatedLink = link.replace(/:\d+/, ':' + val);
          $(this).find(">a").attr('href', updatedLink);
        })
      }
    }
  });

  $('[btn-increase]').on('click', function () {
    var qty = $(this).closest('.quantity-incrementor').find('input[name="quantity"]');
    if (qty) {
      var val = parseInt(qty.val());
      val = isNaN(val) ? 0 : val;
      val++;
      $('.quantity-incrementor input[name="quantity"]').val(val);
      if (val >= 1) {
        $(".order-now-btn").each(function () {
          var link = $(this).find("a").attr('href');
          var updatedLink = link.replace(/:\d+/, ':' + val);
          $(this).find(">a").attr('href', updatedLink);
        })
      }
    }
  });
});

// $(window).on('resize', function(){
//     if($("header .logo-wrapper .search .search-bar").is(":visible")){
//         $("header .logo-wrapper .search .search-bar").hide();
//     }
//     if($("header .menu-wrapper .navbar .bar-wrapper .search-bar").is(":visible")){
//         $("header .menu-wrapper .navbar .bar-wrapper .search-bar").hide();
//     }
// });

(function ($) {

  $(document).ready(function () {

    $(document).on('click', '#add-to-cart-mobile', function (e) {
      e.preventDefault();

      $('#main-product-cta').click();
    });

    $(document).on('lity:open', function (event, instance) {
      history.pushState({}, '', '#video');
    });
    $(document).on('lity:close', function (e, instance) {
      e.preventDefault();
      var scrollV, scrollH, loc = window.location;
      if ("pushState" in history)
        history.pushState("", document.title, loc.pathname + loc.search);
      else {
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;
        loc.hash = "";
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
      }
    });

    var path = window.location.pathname;
    var account_regex = new RegExp("^\/account\/.*");

    if (!account_regex.test(path)) {
      window.addEventListener('popstate', function (event) {
        $('[data-lity-close]', document).trigger('click');
        history.pushState(null, null, window.location.pathname);
      }, false);
    }

    if ($('.js-validate')) {
      $('.js-validate').validate();

      $('.js-validate').find('input[type="submit"]').on('click', function (e) {
        e.preventDefault();

        if ($('.js-validate').valid()) {
          $('.js-validate').submit();
        }
      });
    }

    $(document).on('click', '.address-edit-toggle', function (e) {
      e.preventDefault();
      var target = $(this).attr('data-target-form');
      $('#' + target).toggle();
    });

    $(document).on('click', '.address-new-toggle, #AddressNewButton', function (e) {
      e.preventDefault();
      $('#AddressNewForm').toggle();
    });

    var $starRatingWrap = $('#star-review');
    var starRatingIntervalLimit = 2000;
    var limitCount = 0;

    var starRatingInterval = setInterval(function () {
      $starRatingCound = $starRatingWrap.find('.okeReviews-reviewsSummary-ratingCount > span:nth-child(1)');
      if ($starRatingCound.text() !== '') {
        if ($starRatingCound.text() !== '0 Reviews') {
          $starRatingWrap.css({ opacity: '1' });
          $starRatingWrap.show();
          clearInterval(starRatingInterval);
        }
      }

      if (limitCount > starRatingIntervalLimit) {
        clearInterval(starRatingInterval);
      }
      limitCount = limitCount + 100;
    }, 100);

    var handleBFModal = function () {
      var bfModalShown = Cookies.get('bfModalShown');

      if (!bfModalShown && !/^\/cart|terms-of-service|privacy-policy-us($|\/$)/.test(location.pathname)) {
        var path = window.location.pathname;

        if (path.indexOf('blog') === -1) {
          $('#siteWideModal').modal('show');
        }
        else {
          setTimeout(function () {
            $('#siteWideModal').modal('show');
          }, 10000);
        }
      }
    };

    var currentUrl = new URL(window.location.href);
    var utmMedium = currentUrl.searchParams.get('utm_medium');

    if (utmMedium && utmMedium === 'email') {
      $("#siteWideModal.custom-modal-v2 .modal-dialog .modal-content .modal-header button.close").trigger("click");
      Cookies.set('bfModalShown', true);
    }

    if (getCookieConsentValue('analytics') == "yes") {
      handleBFModal();
    }

    document.addEventListener("cookieyes_consent_update", function (eventData) {
      const data = eventData.detail;
      if (data.accepted.includes("analytics")) {
        handleBFModal();
      }
    });

    window.dataLayer = window.dataLayer || [];
    $('#siteWideModal').on('shown.bs.modal', function () {
      window.dataLayer.push({
        event: 'saleSiteWideModal'
      });
    });

    $('#siteWideModal').on('hidden.bs.modal', function () {
      Cookies.set('bfModalShown', true);
    });

    window.addEventListener("klaviyoForms", function (e) {
      if (e.detail.type === 'submit' && e.detail.formId === 'WwYeFK') {
        Cookies.set('bfModalShown', true);
        var formEmail = e.detail.metaData.$email;
        window.dataLayer.push({
          'event': 'modalSubmit',
          'formEmail': formEmail
        });
        $('#siteWideModal').find('.form-content-wrap').hide();
        $('#siteWideModal').find('#signupMessage').show();
      }
    });

    $("body").tooltip({ selector: '[data-toggle=tooltip]' });
    //$('[data-toggle="tooltip"]').tooltip();

    var checkoutCalculate = true;
    var handleCheckoutFloating = function () {
      if (checkoutCalculate && !$('.cart__submit-controls input[name="checkout"]').isInViewport()) {
        $('.floating-checkout').addClass('active');
      } else {
        $('.floating-checkout').removeClass('active');
      }
    }

    if ($('.floating-checkout').length > 0) {
      handleCheckoutFloating();
      $(window).on('scroll', function () {
        setTimeout(function () {
          handleCheckoutFloating();
        }, 100);
      });
    }

    setInterval(() => {
      $('.ctarget').each(function () {
        $(this).css({
          opacity: '1'
        });
      });
    }, 2000);

  });

  if (jQuery("#cd-pp-calendar").length > 0) {
    let cal_css = '<link rel="stylesheet" type="text/css" href="https://cinnamon.nyc3.cdn.digitaloceanspaces.com/PowerPlate/calendar/2.pp.chunk.css"><link rel="stylesheet" type="text/css" href="https://cinnamon.nyc3.cdn.digitaloceanspaces.com/PowerPlate/calendar/main.pp.chunk.css">'
    jQuery(cal_css).insertBefore("#cd-pp-calendar");

    let cal_js = '<script src="https://cinnamon.nyc3.cdn.digitaloceanspaces.com/PowerPlate/calendar/runtime-main.pp.js"></script><script src="https://cinnamon.nyc3.cdn.digitaloceanspaces.com/PowerPlate/calendar/2.pp.chunk.js"></script><script src="https://cinnamon.nyc3.cdn.digitaloceanspaces.com/PowerPlate/calendar/main.pp.chunk.js"></script>'
    jQuery(cal_js).insertAfter("#cd-pp-calendar");
  }

  jQuery(document).ready(function () {

    // if shop button is not set then make disabled button hidden PDP page
    function shopBtnVisible(event) {
      $('.product-form-actions .shopify-payment-button').each(function () {
        if ($(this).find(".shopify-payment-button__button div[role='button']").attr('aria-disabled') == 'true') {
          $(this).addClass("keep_hide");
        }
        else {
          $(this).removeClass("keep_hide");
        }
      });
    }
    shopBtnVisible();
    var shopBtnVisibleInterval = setInterval(function () {
      shopBtnVisible();
    }, 500);
    setTimeout(function () {
      clearInterval(shopBtnVisibleInterval);
    }, 2000);

  });

})(jQuery);


jQuery(window).on('load', function () {

  // collection page image fix
  function collectionImg(event) {
    jQuery(".collection-product .collection-product--image").height(jQuery(".collection-product .collection-product--image").width());
    jQuery(".collection-product .collection-product--image img").height(jQuery(".collection-product .collection-product--image>a").height());
  };
  collectionImg();
  var collectionImgInterval = setInterval(function () {
    collectionImg();
  }, 500);
  setTimeout(function () {
    clearInterval(collectionImgInterval);
  }, 1500);

  $(".hero_word.words span").eq(0).addClass("active"), TweenMax.defaultEase = Expo.easeOut, TweenMax.force3D = !0; var weDeliver = new TimelineMax; weDeliver.set($(".hero_word__heading"), { y: -10, x: 0, alpha: 0, scale: .75 }), weDeliver.to($(".hero_word__heading"), .25, { x: 0, alpha: 1, scale: 1 }); var word = new TimelineMax; function setNextActiveWord() { var e = $(".hero_word.words .active"); var a = e.next(); a.length || (a = $(".hero_word.words span").eq(0)), a.addClass("active"), e.removeClass("active") } word.set($(".hero_word.words"), { opacity: 0 }), word.to($(".hero_word.words"), .05, { delay: .5, display: "block", opacity: 1 }), word.to($(".hero_word.words"), .5, { scale: 1, ease: Back.easeOut.config(1.7) }), word.to($(".hero_word.words"), .25, { delay: .5, scale: 1, ease: Back.easeOut.config(1.7) }), word.addCallback(animateNextWord); var direction = "y"; function animateNextWord() { "y" == direction && (word.to($(".hero_word.words"), .25, { opacity: 0, y: 20, ease: Back.easeOut.config(1.7) }), word.addCallback(setNextActiveWord), word.to($(".hero_word.words"), 0, { y: -40 }), word.to($(".hero_word.words"), .65, { delay: 0, y: 0, opacity: 1 }), TweenMax.delayedCall(2.5, animateNextWord)), "x" == direction && (word.to($(".hero_word.words"), .25, { opacity: 0, x: 40, ease: Back.easeOut.config(1.7) }), word.addCallback(setNextActiveWord), word.to($(".hero_word.words"), 0, { x: -20 }), word.to($(".hero_word.words"), .65, { delay: 0, x: 0, opacity: 1 }), TweenMax.delayedCall(2.5, animateNextWord)) } function resize() { var e; $(document).width() < 590 || "y" == direction ? weDeliver.to($(".we-deliver"), .5, { y: -10, x: 0, ease: Elastic.easeOut.config(.5) }) : weDeliver.to($(".we-deliver"), .5, { y: -10, x: -180, ease: Elastic.easeOut.config(.5) }) } resize();
});

jQuery(window).on('resize', function () {
  // collection page image fix
  function collectionImg(event) {
    jQuery(".collection-product .collection-product--image").height(jQuery(".collection-product .collection-product--image").width());
    jQuery(".collection-product .collection-product--image img").height(jQuery(".collection-product .collection-product--image>a").height());
  };
  collectionImg();
  var collectionImgInterval = setInterval(function () {
    collectionImg();
  }, 500);
  setTimeout(function () {
    clearInterval(collectionImgInterval);
  }, 2000);
});
